// The schedule mode keys the Employee Reviews API returns. Resolved by key because
// lck.Review_Schedule_Mode ids come from a static-data MERGE rather than an IDENTITY
// column, so they are declared rather than generated.

export const fixedScheduleModeKey = "FIXED";
export const rollingScheduleModeKey = "ROLLING";
